const animation = {
  default: "400ms ease-in",
  fast: "300ms ease-in",
};

const breakpoints = [
  // mobile
  "320px",
  // tablet
  "768px",
  // laptop
  "992px",
  // desktop
  "1200px",
  // widescreen
  "1920px",
];

const colors = {
  background: "#ffffff",
  primary: "#b52f40",
  secondary: "#6D59F0",
  gray: {
    300: "#ccc",
    400: "#ddd",
    500: "#eee",
    600: "#eff0f2",
  },
  white: "#ffffff",
  black: "#000000",
};

const theme = {
  animation,
  breakpoints,
  mediaQueries: {
    mobile: `@media screen and (min-width: ${breakpoints[0]})`,
    tablet: `@media screen and (min-width: ${breakpoints[1]})`,
    laptop: `@media screen and (min-width: ${breakpoints[2]})`,
    desktop: `@media screen and (min-width: ${breakpoints[3]})`,
    widescreen: `@media screen and (min-width: ${breakpoints[4]})`,
  },
  colors,
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96],

  styles: {
    root: {
      fontWeight: "normal",
      lineHeight: "1.5",
    },
  },
};

export default theme;
